export const checkMetamaskAvailability = () => {
  return window.ethereum && window.ethereum.isMetaMask ? true : false;
};
